export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9655.7bbd4bd3.jpg";